import { useMemo } from 'react';

export type AppDomain = 'quantclaw' | 'ailabquant';

/**
 * Detects which domain/mode the app is running in.
 * Checks:
 *   1. REACT_APP_APP_MODE environment variable (for build-time config)
 *   2. Hostname (quantclaw.ai vs ailabquant.com)
 * Returns 'quantclaw' for quantclaw.ai, 'ailabquant' for everything else.
 */
export function useDomainDetection(): AppDomain {
  return useMemo(() => {
    // Check environment variable first (useful for local dev and build config)
    const appMode = process.env.REACT_APP_APP_MODE?.toLowerCase();
    if (appMode === 'quantclaw') {
      return 'quantclaw';
    }

    // Fall back to hostname detection
    const hostname = window.location.hostname.toLowerCase();
    if (hostname.includes('quantclaw')) {
      return 'quantclaw';
    }

    return 'ailabquant';
  }, []);
}

/**
 * Check if we're on the QuantClaw domain (non-hook version)
 */
export function isQuantClawDomain(): boolean {
  const appMode = process.env.REACT_APP_APP_MODE?.toLowerCase();
  if (appMode === 'quantclaw') {
    return true;
  }
  return window.location.hostname.toLowerCase().includes('quantclaw');
}
